<div class="history-container d-flex flex-row">
    <verification-action-indidicator [statusStyle]="statusStyle" [statusIcon]="statusIcon"></verification-action-indidicator>
	<div class="history-content">
		<div class="history-header d-flex flex-row">
			<div class="details">{{actionText}}
				<br>on {{historyItem.VerificationDate | date: 'MMMM dd, yyyy hh:mm a' }}
			</div>
			<div class="email-status" [ngSwitch]="emailStatus">
				<div class="email-status-content" *ngSwitchCase="EmailStatus.SENT">
					<span class="email-status-icon">
						<edl-icon name="envelope" [size]="18" [ariaHidden]="true"></edl-icon>
					</span>
					<div class="email-status-text">
						<button type="button" class="btn btn-link edl-admin-messages email-status-label p-0" *ngIf="canViewMessages()" (click)="messagesClicked()">View Email</button>
						<span class="email-status-label" *ngIf="!canViewMessages()">Email Sent</span>
					</div>
				</div>
				<div class="email-status-content" *ngSwitchCase="EmailStatus.SUPPRESSED">
					<span class="email-status-icon email-suppressed-icon">
						<edl-icon name="envelope-slash" [size]="18" [ariaHidden]="true"></edl-icon>
					</span>
					<div class="email-status-text">
						<span class="email-status-label">No Email Sent</span>
					</div>
				</div>
				<div class="email-status-content" *ngSwitchDefault>
					<span class="email-status-icon"></span>
				</div>
			</div>
		</div>
		<div *ngIf="cycleDateContents as dates" class="alert alert-info small historyAlert date-change-details" role="alert">
			<div *ngIf="dates.NewStartDate || isDateRemoved(dates.PreviousStartDate, dates.NewStartDate)">
				<ng-container *ngIf="dates.NewStartDate">
					Start Date: {{ dates.NewStartDate | dateExtended: 'MM/dd/yyyy' }}
					<span *ngIf="isDateUnchanged(dates.PreviousStartDate, dates.NewStartDate)">(Unchanged)</span>
				</ng-container>
				<ng-container *ngIf="!dates.NewStartDate">Start Date: Removed</ng-container>
			</div>
			<div *ngIf="dates.NewDueDate || isDateRemoved(dates.PreviousDueDate, dates.NewDueDate)">
				<ng-container *ngIf="dates.NewDueDate">
					Due Date: {{ dates.NewDueDate | dateExtended: 'MM/dd/yyyy' }}
					<span *ngIf="isDateUnchanged(dates.PreviousDueDate, dates.NewDueDate)">(Unchanged)</span>
				</ng-container>
				<ng-container *ngIf="!dates.NewDueDate">Due Date: Removed</ng-container>
			</div>
		</div>
		<div *ngIf="followupDateContents as followupDates" class="alert alert-info small historyAlert date-change-details" role="alert">
			<div *ngIf="followupDates.NewFollowupDueDate">
				Follow-Up Due Date: {{ followupDates.NewFollowupDueDate | dateExtended: 'MM/dd/yyyy' }}
			</div>
		</div>
		<div *ngFor="let note of historyItem.VerificationNotes" class="alert alert-info small historyAlert" role="alert">
			{{getFromNoteText(note)}}  <em>{{getFromMessageText(note.Message)}}</em>
		</div>
	</div>

</div>
